import { Injectable } from '@angular/core';
import { UrlTree, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ENavigationErrorType } from '../model/enum/navigation-error-type';
import { ENavigationRoute } from '../model/enum/navigation-route';
import { CoreData } from './core-data/core-data';

@Injectable()
export class LoginGuard {
    constructor(private router: Router,
        private coreData: CoreData) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {

        // return true;

        if (!this.coreData.IsLoggedIn) {
            return this.router.createUrlTree([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthenticated }]);
        }

        const url = route.url[0] === undefined ? ENavigationRoute.Home : route.url[0].path;
        return (this.coreData.IsLoggedIn && this.hasPermission(url))
            || this.router.createUrlTree([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthorized }]);
    }

    hasPermission(url: string) {
        switch (url) {
            case ENavigationRoute.Home:
            case ENavigationRoute.Intervention:
            case ENavigationRoute.DrawingTool:
            case ENavigationRoute.UserConfiguration:
                if (this.coreData.Token) {
                    return true;
                }
                break;
        }
        return false;
    }
}

